if (!customElements.get('beucher-viewport-video')) {
  customElements.define('beucher-viewport-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.visible = false;
      this.onVisibilityChange = () => this.updatePlayback();
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting && entry.intersectionRatio > 0;
        this.updatePlayback();
      });
      this.observer.observe(this.video);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }

    updatePlayback() {
      const video = this.video;
      if (!this.visible || document.hidden) {
        video.pause();
        return;
      }
      if (!video.dataset.loaded) {
        video.poster = video.dataset.poster;
        video.querySelectorAll('source[data-src]').forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.dataset.loaded = 'true';
        video.muted = true;
        video.load();
      }
      video.play().then(() => {
        if (!this.isConnected || !this.visible || document.hidden) video.pause();
      }).catch(() => {});
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.video?.pause();
    }
  });
}
